export default function mapStateToCSRF({ csrfToken }) {
  return { csrfToken };
}
